const lang = {
  default_image: "https://png.pngtree.com/thumb_back/fw800/background/20190221/ourmid/pngtree-autumn-day-color-postcard-exhibition-board-image_32190.jpg",
  list_category: [
    {
      value: 0,
      label: "喪中・寒中"
    },
    {
      value: 1,
      label: "年賀"
    },
    {
      value: 2,
      label: "暑中・残暑"
    },
    {
      value: 3,
      label: "通年"
    }
  ],
  list_type: [
    {
      value: 0,
      label: "一般"
    },
    {
      value: 1,
      label: "カープ"
    },
    {
      value: 2,
      label: "サンフレッチェ広島"
    },
    {
      value: 3,
      label: "広島LOVE"
    },
    {
      value: 4,
      label: "セルフテンプレート"
    }
  ],
};

export default lang;
